import { PlugPag } from '@inhouse-market/sdk';

export const SPLIT_STATUS_OPTIONS = [
    { label: 'Todos', value: PlugPag.EnumSplitStatus.all },
    { label: 'Ativo', value: PlugPag.EnumSplitStatus.active },
    { label: 'Sem split ativo', value: PlugPag.EnumSplitStatus.inactive },
];

export const SPLIT_TYPE_OPTIONS = [
    { label: 'Terminal', value: PlugPag.EnumSplitType.terminal },
    { label: 'Pós', value: PlugPag.EnumSplitType.post },
];

export const EMPTY = '—';

const PILL_BASE = {
    border: 'none',
    borderRadius: 12,
    fontWeight: 500,
    padding: '2px 12px',
    marginInlineEnd: 0,
} as const;

export const PILL_GREEN = {
    ...PILL_BASE,
    background: '#e3f5ea',
    color: '#1f7a52',
};
export const PILL_RED = {
    ...PILL_BASE,
    background: '#ffe4e8',
    color: '#e1425c',
};
export const PILL_BLUE = {
    ...PILL_BASE,
    background: '#e6effd',
    color: '#2f6fe4',
};
export const PILL_GREY = {
    ...PILL_BASE,
    background: '#f0f0f0',
    color: '#595959',
};
